import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

const StudyPieChart = ({data = {}}) => {
  // console.log(data)
  // for(let x = 0; x < Object.keys(data).length; x++){

  // }
  let formattedData = Object.keys(data).map((element) => {
    return({
      "name": element,
      "y": data[element]
    })
  })
  const options = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      height: 372,
    },
    title: {
      text: 'Studies by Recruitment Status',
      align: 'middle'
    },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    },
    plotOptions: {
      pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          // dataLabels: {
          //     enabled: true,
          //     format: '<b>{point.name}</b>: {point.percentage:.1f} %'
          // }
          // tooltip: {
          //   pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          // },
      }
  },
  tooltip: {
    // enabled: true,
    pointFormat: '{point.name}: <b>{point.percentage:.1f}%</b>'
  },
  }
  options.series = {
    "name": "Studies",
    "colorByPoint": true,
    data: formattedData
  }
  console.log(options)
  return(
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
    />
  )
}

export default StudyPieChart